"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ItemManufacturer;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyle = (0, _core.makeStyles)(function (theme) {
  return {
    container: {
      display: "flex"
    },
    left: {
      flex: "100%"
    }
  };
});

function ItemManufacturer(_ref) {
  var manufacturerName = _ref.manufacturerName,
      id = _ref.id,
      props = _ref.props;
  var classes = useStyle();
  return /*#__PURE__*/_react["default"].createElement("div", null, id !== null ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.left
  }, /*#__PURE__*/_react["default"].createElement("span", null, manufacturerName, " "), /*#__PURE__*/_react["default"].createElement("sup", null, "[", id, "]"))) : /*#__PURE__*/_react["default"].createElement("div", null, " "));
}

ItemManufacturer.propTypes = {
  manufacturerName: _propTypes["default"].string,
  id: _propTypes["default"].number
};